import api from './api';

// 扩展字段接口
export interface OrderTrademark {
  id?: number;
  order_id?: number;
  sub_service?: string;
  application_no?: string;
  registration_no?: string;
  trademark_name?: string;
  base_country_trademark_name?: string;
  base_country_application_no?: string;
  base_country_registration_no?: string;
  international_registration_no?: string;
  trademark_image?: number;
  priority?: boolean;
  priority_no?: string;
  priority_date?: string;
  application_basics?: string;
  a1_first_use_at?: string;
  a1_first_commercial_use_at?: string;
  b44_registration_no?: string;
  b44_registration_at?: string;
  d44_application_no?: string;
  d44_application_at?: string;
  trademark_meaning?: string;
  color_statement?: string;
  trademark_type?: string;
  primary_class?: string;
  sub_class?: string;
  assignee_entity_type?: string;
  assignee_name?: string;
  assignee_address?: string;
  assignee_name_en?: string;
  assignee_address_en?: string;
  new_applicant_name?: string;
  new_applicant_name_en?: string;
  new_applicant_address?: string;
  new_applicant_address_en?: string;
  include_transfer_service?: string;
  postpone_type?: string;
  postpone_times?: string;
  postpone_reason?: string;
  assignment_type?: string;
  trademark_status?: string;
  review_type?: string;
  review_times?: string;
  rationale_basis?: string;
  revocation_type?: string;
  search_method?: string;
  oath_type?: string;
  renewal_period?: string;
  original_agent?: string;
  cancellation_reason?: string;
  certificate_type?: string;
  change_items?: string;
  sale_status?: string;
  sold_at?: string;
  created_at?: string;
  updated_at?: string;
}

export interface OrderPatent {
  id?: number;
  order_id?: number;
  sub_service?: string;
  patent_name?: string;
  application_no?: string;
   registration_no?: string;
  include_drawing?: boolean;
  accelerated?: boolean;
  include_authorization?: boolean;
  include_translation?: boolean;
  entity_type?: string;
  priority?: string;
  priority_no?: string;
  open_status?: string;
  opened_at?: string;
  opened_area?: string;
  opened_type?: string[];
  claims_count?: string;
  exceeding_quantity?: number;
  include_document_writing?: boolean;
  patent_type?: string;
  appearance_name?: string;
  review_type?: string;
  rejection_reason?: string;
  postpone_times?: string;
  created_at?: string;
  updated_at?: string;
}

export interface OrderCopyright {
  id?: number;
  order_id?: number;
  registration_no?: string;
  work_name?: string;
  open_status?: string;
  opened_area?: string;
  opened_at?: string;
  opened_type?: string;
  application_type?: string;
  application_category?: string;
  work_inspiration?: string;
  holder_name?: string;
  holder_name_en?: string;
  holder_address?: string;
  holder_address_en?: string;
  assignee_name?: string;
  assignee_name_en?: string;
  assignee_address?: string;
  assignee_address_en?: string;
  created_at?: string;
  updated_at?: string;
}

export interface OrderCompany {
  id?: number;
  order_id?: number;
  sub_service?: string;
  company_no?: string;
  company_name?: string;
  company_address?: string;
  company_type?: string;
  legal_representative?: string;
  include_vat_no?: boolean;
  include_bank_account?: boolean;
  include_foreign_directors?: boolean;
  annual_inspection_times?: string;
  account_bank?: string;
  cancellation_reason?: string;
  change_items?: string[];
  created_at?: string;
  updated_at?: string;
}

export interface OrderBarcode {
  id?: number;
  order_id?: number;
  sub_service?: string;
  application_no?: string;
  company_name?: string;
  quantity?: number;
  validity_period?: string;
  renewal_period?: string;
  cancellation_reason?: string;
  quantity_original?: string;
  quantity_increase?: string;
  created_at?: string;
  updated_at?: string;
}

export interface OrderOther {
  id?: number;
  order_id?: number;
  sub_service?: string;
  created_at?: string;
  updated_at?: string;
}

export interface OrderStatus {
  id?: number;
  order_id?: number;
  status?: string;
  created_at?: string;
  // 状态备注（历史记录中可选）
  remark?: string;
   // 截止日期（可选）
  due_at?: string;
  // 下一个状态（可选）
  next_status?: string;
  // 附件文件 ID 列表（可选）
  files?: number[];
}

export interface Order {
  client_type: string;
  id?: number;
  parent_id?: number;
  client_id?: number;
  client?: {
    id?: number;
    contact_name?: string;
    group_number?: string;
    metas?: Array<{ meta_key: string; meta_value: string }>;
  };
  client_email?: string;
  order_no?: string;
  service?: string;
  nation?: string;
  applicant_name?: string;
  applicant_address?: string;
  applicant_name_en?: string;
  applicant_address_en?: string;
  application_entity_type?: string;
  case_no?: string;
  payment_status?: string;
  payment_at?: string;
  next_status?: string;
  due_at?: string;
  expiration_at?: string;
  price?: number;
  cost?: number;
  profit?: number;
  seller?: number;
  // 仅用于渲染显示（后端 with 关联返回）
  sales?: {
    id?: number;
    contact_name?: string;
    display_name?: string;
    username?: string;
    metas?: Array<{ meta_key: string; meta_value: string }>;
  };
  commission?: number;
  remark?: string;
  group_number?: string;
  files?: string[] | string;
  contact_name?: string;
  channel?: string;
  source?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
  is_monitored?: boolean;
  order_type?: string;

  // 扩展数据关联
  trademark?: OrderTrademark;
  patent?: OrderPatent;
  copyright?: OrderCopyright;
  company?: OrderCompany;
  barcode?: OrderBarcode;
  other?: OrderOther;
  statuses?: OrderStatus[];
  // 统计字段（可选）
  children_count?: number;
}

export interface OrderListParams {
  page?: number;
  per_page?: number;
  search?: string;
  search_field?: string;
  status?: string;
  service?: string;
  sub_service?: string;
  nation?: string;
  case_no?: string;
  payment_status?: string;
  applicant_name?: string;
  contact_name?: string;
  channel?: string;
  source?: string;
  seller?: number;
  sort_by?: string;
  sort_direction?: string;
  parent_id?: number;
  date_field?: 'payment_at' | 'approve_at' | 'announcement_at' | 'decline_at' | 'receipt_at';
  date_from?: string;
  date_to?: string;
  columns?: string[];
}

export interface FilterOption {
  value: string | number;
  label: string;
}

export interface FilterOptionsResponse {
  success: boolean;
  data: {
    nations: FilterOption[];
    services: FilterOption[];
    payment_statuses: FilterOption[];
    applicant_names: FilterOption[];
    contact_names: FilterOption[];
    channels: FilterOption[];
    sources: FilterOption[];
    statuses: FilterOption[];
    sellers: FilterOption[];
  };
}

export interface OrderListResponse {
  success: boolean;
  data: {
    data: Order[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export interface OrderResponse {
  success: boolean;
  message?: string;
  data?: Order;
  errors?: any;
}

class OrderService {
  // 获取订单列表
  async getOrders(params?: OrderListParams): Promise<OrderListResponse> {
    const response = await api.get('/orders', { params });
    return response.data;
  }

  // 获取筛选选项
  async getFilterOptions(params?: { service?: string }): Promise<FilterOptionsResponse> {
    const response = await api.get('/orders/filter-options', { params });
    return response.data;
  }

  // 创建订单
  async createOrder(orderData: Order): Promise<OrderResponse> {
    const response = await api.post('/orders', orderData);
    return response.data;
  }

  // 获取订单详情
  async getOrder(id: number): Promise<OrderResponse> {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  }

  // 更新订单
  async updateOrder(id: number, orderData: Order): Promise<OrderResponse> {
    const response = await api.put(`/orders/${id}`, orderData);
    return response.data;
  }

  // 删除订单
  async deleteOrder(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/orders/${id}`);
    return response.data;
  }

  // 批量删除订单
  async batchDeleteOrders(ids: number[]): Promise<{ success: boolean; message: string; data?: { deleted_count: number } }> {
    const response = await api.post('/orders/batch-delete', { ids });
    return response.data;
  }

  // 批量更新订单
  async batchUpdateOrders(params: {
    ids: number[];
    data: Record<string, any>
  }): Promise<{ success: boolean; message: string; data?: any }> {
    const response = await api.post('/orders/batch-update', params);
    return response.data;
  }

  // 导出订单数据
  async exportOrders(params?: OrderListParams): Promise<Blob> {
    const response = await api.get('/orders-export', {
      params,
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
    return response.data;
  }

  // 导入订单数据
  async importOrders(file: File, service?: string): Promise<{ success: boolean; message: string; data?: any }> {
    const formData = new FormData();
    formData.append('file', file);
    if (service) {
      formData.append('service', service);
    }

    const response = await api.post('/orders-import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }

  // 获取订单状态历史
  async getStatusHistory(id: number): Promise<{ success: boolean; data: OrderStatus[] }> {
    const response = await api.get(`/orders/${id}/status-history`);
    return response.data;
  }

  // 添加订单状态
  async addStatus(
    id: number,
    status: string | undefined | null,
    opts?: { updateOrderStatus?: boolean; remark?: string; created_at?: string; next_status?: string; due_at?: string | null; expiration_at?: string | null; files?: number[]; application_no?: string; registration_no?: string }
  ): Promise<{ success: boolean; message: string; data?: OrderStatus }> {
    const response = await api.post(`/orders/${id}/status`, {
      status,
      update_order_status: opts?.updateOrderStatus,
      remark: opts?.remark,
      created_at: opts?.created_at,
      next_status: opts?.next_status,
      due_at: opts?.due_at,
      expiration_at: opts?.expiration_at,
      files: opts?.files,
      application_no: opts?.application_no,
      registration_no: opts?.registration_no,
    });
    return response.data;
  }

  // 删除订单状态
  async deleteStatus(orderId: number, statusId: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/orders/${orderId}/status/${statusId}`);
    return response.data;
  }

  // 获取业务选项
  async getServiceOptions(service: string): Promise<{ success: boolean; data: Record<string, string> }> {
    const response = await api.get('/orders/service-options', {
      params: { service }
    });
    return response.data;
  }
}

const orderService = new OrderService();
export default orderService;
